import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { ThreeDotsVertical } from "react-bootstrap-icons";

const MenuPopover = ({ children, show, setShow }) => {
  return (
    <OverlayTrigger
      trigger="focus"
      placement="bottom"
      overlay={
        <Popover className="popover-modern mt-1">
          <Popover.Body className="p-0">{children}</Popover.Body>
        </Popover>
      }
    >
      <Button
        variant="transparent"
        size="sm"
        className="border-0 d-flex align-items-center justify-content-center"
        onClick={() => setShow(!show)}
        style={{
          width: "32px",
          height: "32px",
          borderRadius: "var(--radius-full)",
          color: "var(--text-secondary)",
        }}
      >
        <ThreeDotsVertical />
      </Button>
    </OverlayTrigger>
  );
};

export default MenuPopover;
